import { create } from 'zustand';

import { DateFilterStep } from './types';

interface DateFiltersState {
  step: DateFilterStep;
}

interface DateFiltersActions {
  setStep: (step: DateFilterStep) => void;
}

type DateFiltersStore = DateFiltersState & DateFiltersActions;

const initialState: DateFiltersState = {
  step: 'main',
};

export const useDateFilterStore = create<DateFiltersStore>((set) => ({
  ...initialState,
  setStep: (step: DateFilterStep) => {
    set({ step });
  },
}));
